import { ShieldCheck, Lock, BadgeCheck } from "lucide-react";

const badges = [
  { icon: BadgeCheck, title: "Verified Platform Network", desc: "Every trading platform independently vetted & regulated" },
  { icon: Lock, title: "256-bit Encryption", desc: "Bank-grade security on all your data" },
  { icon: ShieldCheck, title: "Unbiased Matching", desc: "Our AI works for you, not the trading platforms" },
];

export const TrustBadges = () => (
  <section className="px-4 sm:px-6 pb-16">
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
      {badges.map((b, i) => (
        <div
          key={i}
          data-testid={`trust-badge-${i}`}
          className="flex items-start gap-4 bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-md transition-shadow duration-200"
        >
          <span className="w-11 h-11 shrink-0 rounded-xl bg-blue-50 flex items-center justify-center">
            <b.icon className="w-5 h-5 text-blue-600" />
          </span>
          <div>
            <h3 className="font-bold text-gray-900 text-sm">{b.title}</h3>
            <p className="text-sm text-gray-500 mt-1">{b.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
